import { cx } from '@/utils/cx'

const toggleBullet = (type: 'positive' | 'negative', fillColor: string) => {
  switch (type) {
    case 'positive':
      return (
        <svg
          aria-hidden="true"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.2025 8.72719C14.4207 8.52258 14.4318 8.1798 14.2272 7.96156C14.0226 7.74332 13.6798 7.73226 13.4616 7.93687L9.38773 11.7562L7.53582 10.0202C7.31757 9.81559 6.97478 9.82666 6.77019 10.0449C6.56559 10.2632 6.57666 10.6059 6.79491 10.8105L9.01729 12.8939C9.22565 13.0892 9.54987 13.0892 9.75822 12.8939L14.2025 8.72719Z"
            fill={fillColor}
          />
          <path
            d="M10.4987 1.95703C6.05741 1.95703 2.45703 5.55741 2.45703 9.9987C2.45703 14.44 6.05741 18.0404 10.4987 18.0404C14.94 18.0404 18.5404 14.44 18.5404 9.9987C18.5404 5.55741 14.94 1.95703 10.4987 1.95703ZM3.54036 9.9987C3.54036 6.15572 6.65572 3.04036 10.4987 3.04036C14.3417 3.04036 17.457 6.15572 17.457 9.9987C17.457 13.8417 14.3417 16.957 10.4987 16.957C6.65572 16.957 3.54036 13.8417 3.54036 9.9987Z"
            fill={fillColor}
          />
        </svg>
      )

    case 'negative':
      return (
        <svg
          aria-hidden="true"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2096 2.7513C6.36665 2.7513 3.2513 5.86665 3.2513 9.70964C3.2513 13.5526 6.36665 16.668 10.2096 16.668C14.0526 16.668 17.168 13.5526 17.168 9.70964C17.168 5.86665 14.0526 2.7513 10.2096 2.7513ZM2.16797 9.70964C2.16797 5.26835 5.76835 1.66797 10.2096 1.66797C14.6509 1.66797 18.2513 5.26835 18.2513 9.70964C18.2513 14.1509 14.6509 17.7513 10.2096 17.7513C5.76835 17.7513 2.16797 14.1509 2.16797 9.70964ZM13.5389 6.3803C13.7505 6.59183 13.7505 6.9348 13.5389 7.14633L10.9756 9.70961L13.5389 12.2729C13.7504 12.4844 13.7504 12.8274 13.5389 13.0389C13.3274 13.2504 12.9844 13.2504 12.7729 13.0389L10.2096 10.4756L7.64636 13.0389C7.43483 13.2504 7.09187 13.2504 6.88033 13.0389C6.6688 12.8274 6.6688 12.4844 6.88033 12.2729L9.44358 9.70961L6.8803 7.14633C6.66877 6.9348 6.66877 6.59183 6.8803 6.3803C7.09183 6.16877 7.4348 6.16877 7.64633 6.3803L10.2096 8.94358L12.7729 6.3803C12.9844 6.16877 13.3274 6.16877 13.5389 6.3803Z"
            fill={fillColor}
          />
        </svg>
      )
  }
}

interface PasswordRequirementProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any
  requirementMet?: boolean
  passwordFilled?: boolean
}

export const PasswordRequirement = (props: PasswordRequirementProps) => {
  if (!props.passwordFilled)
    return (
      <div className="enpal__password-requirement-met">
        <div>
          <svg
            aria-hidden="true"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.0002 1.95703C5.55887 1.95703 1.9585 5.55741 1.9585 9.9987C1.9585 14.44 5.55887 18.0404 10.0002 18.0404C14.4415 18.0404 18.0418 14.44 18.0418 9.9987C18.0418 5.55741 14.4415 1.95703 10.0002 1.95703ZM3.04183 9.9987C3.04183 6.15572 6.15718 3.04036 10.0002 3.04036C13.8431 3.04036 16.9585 6.15572 16.9585 9.9987C16.9585 13.8417 13.8431 16.957 10.0002 16.957C6.15718 16.957 3.04183 13.8417 3.04183 9.9987Z"
              fill="black"
            />
          </svg>
        </div>
        <div>{props.children}</div>
      </div>
    )

  return (
    <div className={cx('enpal__password-requirement-met', (!!props.requirementMet).toString())}>
      <div>
        {toggleBullet(
          props.requirementMet ? 'positive' : 'negative',
          props.requirementMet ? '#037257' : '#B62424'
        )}
      </div>
      <div>{props.children}</div>
    </div>
  )
}
